import Main from './Main'

export default [
  { path: '/pda', component: Main, name: 'pda.main' }
]
